var map = {
	"./adult.svg": 28518,
	"./angle-down-white.svg": 1932,
	"./angle-down.svg": 25244,
	"./angle-left-blue.svg": 75640,
	"./angle-left.svg": 5163,
	"./angle-purple.svg": 26486,
	"./arrow-down-warning.svg": 16829,
	"./arrow-down.svg": 92902,
	"./arrow-sort.svg": 33806,
	"./arrow-up-danger.svg": 17775,
	"./arrow.svg": 60809,
	"./arrow_more.svg": 93247,
	"./arrow_tr.svg": 66330,
	"./attachment.svg": 16705,
	"./buildings.svg": 2001,
	"./calendar-input.svg": 35559,
	"./calendar.svg": 30600,
	"./calendar_black.svg": 18644,
	"./calendar_star.svg": 14491,
	"./car.svg": 72792,
	"./chart.svg": 3574,
	"./chart_bar.svg": 42784,
	"./chart_line.svg": 87095,
	"./check-green.svg": 4464,
	"./check-white.svg": 86990,
	"./check.svg": 46018,
	"./check_success.svg": 76290,
	"./checked.svg": 32885,
	"./checked2.svg": 9789,
	"./clock-full.svg": 85190,
	"./clock.svg": 4696,
	"./close-circle-white.svg": 52427,
	"./close-light.svg": 4917,
	"./close-modal.svg": 25106,
	"./close-modal2.svg": 79660,
	"./close.svg": 58302,
	"./cluster.svg": 68896,
	"./copy.svg": 47193,
	"./crosshair.svg": 43674,
	"./crosshair_2.svg": 85393,
	"./customised_nutrition.svg": 33625,
	"./dots_list.svg": 14773,
	"./download.svg": 66442,
	"./download_results.svg": 24121,
	"./drag.svg": 12768,
	"./edit.svg": 18614,
	"./edit_accent.svg": 20119,
	"./edit_gray.svg": 556,
	"./envelope.svg": 67674,
	"./equalizer.svg": 7822,
	"./error-mobile.svg": 115,
	"./error.svg": 4880,
	"./eye-close.svg": 60334,
	"./eye.svg": 1005,
	"./file.svg": 56992,
	"./files.svg": 39395,
	"./filters.svg": 73059,
	"./fire.svg": 29910,
	"./flag_banner_fold.svg": 41021,
	"./flag_pennant.svg": 72537,
	"./for_own_package.svg": 26779,
	"./hamburger.svg": 46955,
	"./headphones.svg": 36711,
	"./hide-line.svg": 72169,
	"./info-black.svg": 68512,
	"./info-primary.svg": 14271,
	"./info-secondary.svg": 67679,
	"./info.svg": 42930,
	"./info_gray.svg": 94976,
	"./kid.svg": 8022,
	"./list.svg": 97454,
	"./list_bullets.svg": 11796,
	"./list_white.svg": 17840,
	"./magnifier_accent.svg": 61007,
	"./magnifying-glass.svg": 80966,
	"./mail.svg": 48367,
	"./mapPin.svg": 21277,
	"./map_pin_simple.svg": 24889,
	"./marker-active.svg": 41015,
	"./marker.svg": 60972,
	"./marker_outline.svg": 23715,
	"./message.svg": 61983,
	"./message_accent.svg": 3160,
	"./meteor.svg": 7482,
	"./microphone_disconnected.svg": 42036,
	"./microphone_white.svg": 4672,
	"./microscope.svg": 89938,
	"./new_file.svg": 86489,
	"./phone_disconnected.svg": 38280,
	"./play_circle.svg": 50947,
	"./plus-accent.svg": 14837,
	"./plus-blue.svg": 82647,
	"./plus-darkblue.svg": 57559,
	"./plus.svg": 47670,
	"./printer.svg": 19990,
	"./question_circle.svg": 49585,
	"./resize.svg": 758,
	"./right_direct_arrow.svg": 74322,
	"./search.svg": 26370,
	"./search_accent.svg": 3803,
	"./search_white.svg": 29844,
	"./send.svg": 55740,
	"./share_screen_disconnected.svg": 76204,
	"./share_screen_white.svg": 9256,
	"./shopping_cart.svg": 50571,
	"./sneaker_move.svg": 90757,
	"./sport.svg": 28952,
	"./stethoscope.svg": 44897,
	"./success.svg": 1611,
	"./sun.svg": 9152,
	"./syringe.svg": 90197,
	"./time_accent.svg": 86842,
	"./trash.svg": 2508,
	"./user.svg": 37299,
	"./user_settings.svg": 71909,
	"./video_camera_disconnected.svg": 3059,
	"./video_camera_white.svg": 73297,
	"./wallet.svg": 57845,
	"./warning_circle.svg": 46901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75176;